import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import UsageMeter from '../../components/UsageMeter';
import styles from './ProductAdmin.module.css';
import t from './AdminTable.module.css';

function planBadge(subscription) {
  if (!subscription) return null;
  if (subscription.status !== 'active') return <span className={`${t.badge} ${t.badgeDanger}`}>Expired</span>;
  if (subscription.is_trial) return <span className={`${t.badge} ${t.badgeInfo}`}>Trial</span>;
  return <span className={`${t.badge} ${t.badgeSuccess}`}>Active</span>;
}

// Plan, document limit and activity for each organization
export default function OrganizationsTable({ companies, searching }) {
  const navigate = useNavigate();
  return (
    <div className={t.wrap}>
      <table className={t.table}>
        <thead>
          <tr>
            <th>Organization</th>
            <th className={t.wPlan}>Plan</th>
            <th className={`${t.wStat} ${t.num} ${t.hideSm}`}>Licences</th>
            <th className={`${t.wMeter} ${t.hideXs}`}>No. of Documents</th>
            <th className={t.action} />
          </tr>
        </thead>
        <tbody>
          {companies.map(item => {
            const current = item.subscriptions?.[0];
            const docs = item.documents || {};
            const adminCount = `${item.admins.length} admin${item.admins.length === 1 ? '' : 's'}`;
            return (
              <tr key={item.admins[0]?.id || item.company.company_name}>
                <td>
                  <div className={t.stack}>
                    <span className={t.name} title={item.company.company_name}>{item.company.company_name}</span>
                    <span className={t.muted} title={adminCount}>{adminCount}</span>
                  </div>
                </td>
                <td className={t.fit}>
                  {current ? (
                    <div className={t.stack}>
                      <span title={current.plan_name || ''}>{current.plan_name || '—'}</span>
                      {planBadge(current)}
                    </div>
                  ) : <span className={t.muted}>No plan</span>}
                </td>
                <td className={`${t.num} ${t.hideSm}`} title={String(docs.licences || 0)}>{docs.licences || 0}</td>
                <td className={`${t.fit} ${t.hideXs}`}>
                  {docs.unlimited || docs.document_limit
                    ? <UsageMeter size="sm" used={docs.documents_used} limit={docs.document_limit} unlimited={docs.unlimited} />
                    : <span className={t.muted}>—</span>}
                </td>
                <td className={t.action}>
                  <Button size="sm" variant="secondary" className={t.softButton} onClick={() => navigate(`/product-admin/company/${item.admins[0]?.id}`)}>
                    Manage
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {!companies.length && (
        <div className={styles.emptyState}>
          <strong>No organizations found</strong>
          <span>{searching ? 'Try a different search.' : 'Organizations appear here after they register.'}</span>
        </div>
      )}
    </div>
  );
}
